import React from 'react';
import styles from './TextInput.module.css';
import PropTypes from 'prop-types';

const TextInput = (props) => {
  return (
    <div>
      <h4>{props.label}</h4>
      <div className={styles.inputField}>
        <input
          type="text"
          name={props.name}
          className={styles.inputArea}
          value={props.value}
          onChange={props.onChange}
          onKeyDown={props.onKeyDown}
        />
      </div>
    </div>
  );
};

TextInput.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
};

export default TextInput;
